export default function TitledItem({title, comments}){
  return (
    <div className="mb-8">
      <p className="text-sm text-[#396180] lg:text-base">{title}</p>
      <div className="h-[1px] bg-sky-700 w-12 my-1"/>
      {comments.map((comment, index)=>{
        return(
          <div key={index} className="flex flex-row mb-2">
            <p className="mr-1.5 text-xs text-gray-400 lg:text-sm">-</p>
            <p className="text-xs tracking-wide text-gray-400 lg:text-sm" dangerouslySetInnerHTML={{__html:comment}}></p>
          </div>
        );
      })}
    </div>
  );
}